import { pusherKey, pusherCluster, backendUrl } from '../app-globals';
import Pusher from 'pusher-js';
import Vue from 'vue';
import store from '../store';
import constants from '../constants';

const userData = store.getters['adminuser/getUser'];

// create pusher instance
const pusher = new Pusher(pusherKey, {
    cluster: pusherCluster,
    wssPort: 443,
    enabledTransports: ['ws'],
    forceTLS: true,
    encrypted: true,
    auth: {
        headers: {
            Authorization: `Bearer ${userData.token}`,
        },
    },
    authEndpoint: `${backendUrl}/api/broadcasting/auth`,
});

Vue.prototype.$pusher = pusher;

// organization channel
var dbsManageChannel = pusher.subscribe(constants.SOCKET_DBS_ADMIN_CHANNEL);
dbsManageChannel.bind(`${constants.SOCKET_BOARD_REGISTRATION_SUCCESS}`, (e) => {
    store.dispatch('notifications/recordMessage', e);
    store.dispatch('digiboards/addDeviceRegistrationSuccessData', e);
});

export default pusher;
